export default function PageHome() {
  const now = new Date();

  const endDate = new Date('2026-11-20T00:00:00');
  const showParagrafVaccins = now < endDate;

  return (
    <div className="max-w-4xl mx-auto px-4">
      <h1 className="text-2xl font-bold mb-4">Welkom bij Artsenpraktijk Waarloos</h1>

      {showParagrafVaccins && (
      <div>
      <h3 style={{ marginBottom: '6px'}}>Najaarsvaccinaties</h3>        
        <p>Beste patiënt,</p>
        <p>Ook dit najaar organiseren wij in onze praktijk vaccinatiemomenten tegen <strong> COVID-19 en griep</strong>.</p>
        <p>Vaccinatie wordt in het bijzonder aanbevolen voor:<br/>
          <ul>
            <li>personen van <strong>65 jaar en ouder</strong>;</li>
            <li>personen met bepaalde <strong>chronische aandoeningen</strong> of een <strong>verminderde afweer</strong>;</li>
            <li>personen met een <strong>BMI van 40 of hoger</strong>;</li>
            <li>personen die in een <strong>woonzorgcentrum of andere zorginstelling</strong> verblijven;</li>
            <li><strong>zorgverleners;</strong></li>
            <li>personen die samenwonen met iemand met een ernstige immuunstoornis;</li>
            <li><strong>zwangere vrouwen</strong>: griepvaccinatie wordt aanbevolen; COVID-vaccinatie wordt aanbevolen afhankelijk van de individuele situatie.</li>
          </ul>
        </p><br/>
        <p><strong>Onze vaccinatiemomenten</strong></p>
        <p><strong>Donderdag 15 oktober | 11u-12u</strong><br/>
          Enkel <strong>COVID-vaccintatie</strong></p>
        <p><strong>Woensdag 28 oktober | 16u30-17u30</strong><br/>
          <strong>COVID- en griepvaccinatie</strong><br/>
          Beide vaccins kunnen gelijktijdig worden toegediend.</p>
        <p><strong>Donderdag 19 november | 11u-12u</strong><br/>
        Enkel <strong>griepvaccinatie</strong></p>
        <br/>
        <p><strong>Belangrijk: maak vooraf een afspraak</strong></p>
        <p>Voor <strong>elk vaccinatiemoment is een afspraak verplicht</strong>. Gelieve hiervoor contact op te nemen met ons secretariaat.</p>
        <p><strong>COVID-vaccin: </strong> wij voorzien dit in de praktijk. U hoeft niets mee te brengen.</p>
        <p><strong>Griepvaccin: </strong> u brengt uw vaccin <strong>zelf mee</strong> naar de afspraak. Dit kan zonder voorschrift bij de apotheek worden afgehaald.<br/>
          <ul>
            <li>&lt; 65 jaar: standaard griepvaccin</li>
            <li>≥ 65 jaar: bij voorkeur een <strong>geadjuveerd of hooggedoseerd griepvaccin</strong></li>
          </ul>
        </p>
        <p><strong>Kom indien mogelijk te voet of met de fiets</strong></p>
        <p>
          Onze parkeermogelijkheden zijn beperkt. Daarom willen we u vriendelijk vragen om, 
          indien mogelijk, te voet of met de fiets naar het vaccinatiemoment te komen. Zo 
          houden we de beschikbare parkeerplaatsen vrij voor patiënten die minder mobiel zijn.
        </p><br/>
        <p>Met vriendelijke groeten,</p>
        <p><strong>Dr. Borms, Dr. Gilis, Dr. Haccuria, Dr. Moehlig en Dr. Vermeiren</strong></p>
        <p><strong>Artsenpraktijk Waarloos</strong></p>
      </div>
      )}
      

      <h3 style={{ marginBottom: '6px'}}>Mondmaskers</h3>
      <p>
        Bij verkoudheid, griep of andere virale infecties vragen we vriendelijk om een mondmasker te dragen, ter bescherming van anderen. 
      </p>

      <h3 style={{ marginBottom: '6px'}}>Tabakoloog</h3>
      <p>
        Martijn is tabakoloog en begeleidt dus patiënten bij stoppen met roken. Hij werkt sinds kort twee donderdagen per maand op onze praktijk. Voor meer informatie, zie ook tabblad <strong><a href="/team/">Team</a></strong>.
      </p>

      <h3 style={{ marginBottom: '6px'}}>Diëtiste</h3>
      <p>
        Vanaf 05/01/ 2026 zal Yana Van Gastel ons team versterken als diëtiste.
        Ze zal elke maandagvoormiddag in onze praktijk werken van 8u tot 12u30.
      </p>
      <p> Voor meer informatie, zie ook tabblad <strong><a href="/team/">Team</a></strong>.<br/>Welkom Yana!</p>

      <h3 style={{ marginBottom: '6px'}}>Verpleegkundige</h3>
      <p>
        Elke woensdag is het mogelijk om op afspraak bloed te laten prikken bij een verpleegkundige van 8 tot 10u in onze praktijk. 
        Dit kan enkel indien u over een aanvraagformulier van een arts beschikt.
      </p>
      <p> Een afspraak maken kan telefonisch tijdens de openingsuren van het secretariaat.</p>

      <h3 style={{ marginBottom: '6px'}}>Psychotherapeute</h3>
      <p>
        Annelien Wilms komt op vrijdagnamiddag en donderdagvoormiddag ons team versterken als psychotherapeute. 
        Een afspraak maken kan rechtstreeks telefonisch via het secretariaat, of indien gewenst kan een 
        verwijzing eerst besproken worden met een van de huisartsen op de raadpleging.
      </p>
      <p>Meer informatie is ook terug te vinden bij het tabblad <strong><a href="/team/">Team</a></strong>.</p>

      <img
        src="/images\2025.05\Groep_cropped-w945.jpg"
          alt="Artsenpraktijk Waarloos"
        className="w-full max-w-3xl rounded shadow-md"
        />
    </div>
  );
}